var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCross(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 1.7188212,0.0044129 A 1.7109153,1.7109153 0 0 0 0.52597812,2.9414131 L 9.5808948,11.996329 0.52597812,21.051245 a 1.7109153,1.7109153 0 1 0 2.41909908,2.419099 l 9.0549158,-9.054917 9.054917,9.054917 a 1.7109153,1.7109153 0 1 0 2.419098,-2.419099 L 14.419092,11.996329 23.474008,2.9414131 A 1.7109153,1.7109153 0 0 0 22.231046,0.0044129 1.7109153,1.7109153 0 0 0 21.05491,0.522314 L 11.999993,9.5772306 2.9450772,0.522314 A 1.7109153,1.7109153 0 0 0 1.7188212,0.0044129 Z",
    id: "path2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCross);
export default __webpack_public_path__ + "static/media/icon-cross.ed3fb650e0abc7a5f8a86788f3c83c27.svg";
export { ForwardRef as ReactComponent };